import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';

import { setKustomerWindowProperty } from 'utils';
import IntlExposer from 'i18n/IntlExposer';
import * as localeHelpers from 'i18n/locale';

export default class AppIntl extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      messages: null,
      localeData: null,
    };
  }

  componentDidMount() {
    localeHelpers.getMessages().then(messagesModule => {
      setKustomerWindowProperty('_loadedEvents.langFile', true);
      const messages = messagesModule.default;

      this.setState({
        messages,
      });
    });

    localeHelpers.getLocaleData().then(localeModule => {
      setKustomerWindowProperty('_loadedEvents.localeFile', true);
      const localeData = localeHelpers.formatLocaleData(localeModule.default);

      addLocaleData(Object.values(localeData));

      this.setState({
        localeData,
      });
    });
  }

  render() {
    const { localeData, messages } = this.state;

    if (!localeData || !messages) return null;

    const providerData = localeData[localeHelpers.locale] || {};
    const providerFields = providerData && providerData.fields;
    const providerLocale = providerData.parentLocale || providerData.locale || localeHelpers.locale;

    return (
      <IntlProvider locale={providerLocale} messages={messages} formats={providerFields}>
        <div>
          <IntlExposer />
          {this.props.children}
        </div>
      </IntlProvider>
    );
  }
}

AppIntl.propTypes = {
  children: PropTypes.node,
};

AppIntl.defaultProps = {
  children: null,
};
